export default __webpack_public_path__ + "static/media/pencil-black.b80e30ec.svg";